import { StandardAsset } from '$components/Asset';
import { HTMLAttributes, useEffect, useState } from 'react';

import { ITimelineAsset } from './';

export function TimelineImage(
  props: ITimelineAsset & HTMLAttributes<HTMLElement>,
) {
  const { assets, coverClass } = props;

  const [devicePixelRatio, setDevicePixelRatio] = useState(1);
  useEffect(() => {
    setDevicePixelRatio(Math.min(2, window.devicePixelRatio));
  }, []);

  return (
    <StandardAsset
      sizes={
        '(max-width: ' +
        Math.floor(768 * devicePixelRatio) +
        'px) ' +
        Math.floor(768 / devicePixelRatio) +
        'px, ' +
        Math.floor(1440 / devicePixelRatio) +
        'px'
      }
      assets={assets}
      customClass={coverClass}
    />
  );
}
